import SuperRepository from '../superRepository'

export default new (class PaymentModelsRepository extends SuperRepository {
  baseUri() {
    return 'payment_model'
  }
})()
